module.exports = __webpack_public_path__ + "img/stopwatch.98e32ed4.svg";